export let CosmeticTabs;

(function (CosmeticTabs) {
  CosmeticTabs["AVATAR"] = "avatar";
  CosmeticTabs["AVATAR_FRAME"] = "avatarFrame";
})(CosmeticTabs || (CosmeticTabs = {}));